
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import CreateCard from "../pages/create-card/page";
import AdminUsers from "../pages/admin/users/page";
import Ranking from "../pages/ranking/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/create-card",
    element: <CreateCard />,
  },
  {
    path: "/admin/users",
    element: <AdminUsers />,
  },
  {
    path: "/ranking",
    element: <Ranking />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
